import { render, staticRenderFns } from "./FeedbackContent.vue?vue&type=template&id=21583a06&scoped=true"
import script from "./FeedbackContent.vue?vue&type=script&lang=js"
export * from "./FeedbackContent.vue?vue&type=script&lang=js"
import style0 from "./FeedbackContent.vue?vue&type=style&index=0&id=21583a06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21583a06",
  null
  
)

export default component.exports